<template>
    <div class="m-faq">        
        <Nav :isFixed='bannerFixed'></Nav>
       <div class="faq-banner">
            <div class="main-text">
                <p class="headline">Frequently Asked <span class="underline">Questions?</span> </p>
            </div>
        </div>
        <div class="faq-main">
            <div class="faq-right">
                <el-collapse v-model="activeItem" accordion>
                    <el-collapse-item :title="item.q" v-for="(item,i) in aqList" :key='i' :name="i" class="collapse-item">
                        <div>{{ item.a }}</div>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </div>
    <Bottom></Bottom>
    </div>
</template>
<script>
import Nav from '../components/mobile/m_nav.vue'
import { faqList } from '@/utils/faqList'
import Bottom from '../components/mobile/m_bottom.vue'
export default {
    data () {
        return {
            bannerFixed: false,
            aqList: faqList,
            activeItem: 0
        }
    },
    components: {
        Nav,
        Bottom
    },
    mounted () {
        this.handleScroll()
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        choseQuestion (index) {
            this.activeItem = index
        },
        handleScroll () {
            if (window.scrollY > 80) {
                this.bannerFixed = true
            } else {
                this.bannerFixed = false
            }
        }
    },
}
</script>
<style lang='scss'>
@import '@/styles/public.scss';
.m-faq{
    .faq-banner{
        width: 100%;
        height: 1320px;
        background-image: url('~@/assets/img/mobile/faq-banner.png');
        background-repeat: no-repeat;
        background-size: contain;
        position: relative;
        overflow: hidden;
        .main-text{
            position: absolute;
            top: 350px;
            left: 140px;
            width: 1112px;
            .headline{
                font-size: 92px;
                color: #060F27;
                margin-bottom: 16px;
                font-weight: bold;
                text-align: center;
                .underline{
                    color: $theme-color;
                    display: inline-block;
                    border-bottom: 8px solid $theme-color;
                    line-height: 70px;
                }
            }
        }
    }
    .faq-main{
        overflow: hidden;
        padding: 0 60px;
        padding-top: 90px;
        .faq-right{
            float: left;
            flex: 1;
            .el-collapse{
                border: none;
                .el-collapse-item__header{
                    font-size: 62px;
                    font-weight: bold;
                    color: $theme-color;
                    height: auto;
                    line-height: 80px;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 20px;
                    margin-bottom: 34px;
                }
                .collapse-item{
                    white-space: pre-wrap;
                    margin-bottom: 100px;
                }
                .el-collapse-item__wrap{
                    border: none;
                    .el-collapse-item__content{
                        padding-left: 40px;
                        font-size: 50px;
                        color: #565D75;
                    }
                }
            }
        }

    }
}
</style>
